import React from 'react';
import { Helper } from '../static/helper';
import entree3 from '../images/Entree3.jpeg'
import entree2 from '../images/Entree2.jpeg'
import entree1 from '../images/Entree1.jpeg'
import imgSalle1 from '../images/Salle1.jpeg'
import imgSalle2 from '../images/Salle2.jpeg'

const Portfolio = () => {
    return (
        <>
            <div className="my-4 py-4" id='portfolio'>
                <h2 style={{ color: Helper.footerBackGroundColor }} className="my-2 text-center text-3xl uppercase font-bold">Votre centre chiropratique</h2>
                <div className='flex justify-center'>
                    <div style={{ borderColor: Helper.footerBackGroundColor }} className='w-24 border-b-4 mb-8'></div>
                </div>

                <div className="px-4" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-1 gap-5" style={{ display:"flex", justifyContent: "center" }}>
                        <div  className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                            <img style={{ maxHeight: 300 }} src={entree3} />
                            <div className="flex justify-center my-4">
                            </div>
                        </div>
                        <div  className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                            <img style={{ maxHeight: 300 }} src={entree2} />
                            <div className="flex justify-center my-4">
                            </div>
                        </div>
                        <div  className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                            <img style={{ maxHeight: 300 }} src={entree1} />
                            <div className="flex justify-center my-4">
                            </div>
                        </div>
                        <div  className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                            <img style={{ maxHeight: 300 }} src={imgSalle1} />
                            <div className="flex justify-center my-4">
                            </div>
                        </div>
                        <div  className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                            <img style={{ maxHeight: 300 }} src={imgSalle2} />
                            <div className="flex justify-center my-4">
                            </div>
                        </div>

                        {/*  <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
                            <div className="m-2 text-justify text-sm">
                                <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">Photo 2</h4>
                                <div className="flex justify-center my-4">
                                </div>

                               <ul className="border-t border-gray-300 py-8 space-y-6">
                                    <li className="flex items-center space-x-2 px-8">
                                        <span className="bg-blue-600 rounded-full p-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                            </svg>
                                        </span>
                                        <span className="text-gray-600 capitalize">Free Setup Guidance</span>
                                    </li>
                                </ul> 
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
                            <div className="m-2 text-justify text-sm">
                                <img style={{ }} src={localdevanture2} />
                            </div>
                        </div>

                        <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
                            <div className="m-2 text-justify text-sm">
                                <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">Photo 4</h4>
                            </div>
                        </div>      */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Portfolio;